//
//
//
//
//
//
//
//
import { mapState, mapMutations } from 'vuex';
export default {
  props: {
    router: {
      type: String,
      default: null
    }
  },
  computed: {// ...mapState(['quickApplyStep'])
  },
  data: function data() {
    return {};
  },
  methods: {
    // 继续新建按钮,直接退回到第一步
    continuCreate: function continuCreate() {
      if (this.router == 'createProject') {
        this.$emit("callBack"); // this.$router.go(0)
      } else {
        this.$router.go(-3);
      }
    }
  }
};